"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _useAutocomplete = _interopRequireDefault(require("@material-ui/lab/useAutocomplete"));
var _AirplanemodeActive = _interopRequireDefault(require("@material-ui/icons/AirplanemodeActive"));
var _FlightTakeoff = _interopRequireDefault(require("@material-ui/icons/FlightTakeoff"));
var _TextField = _interopRequireDefault(require("../../TextField"));
var _ListItem = _interopRequireDefault(require("../../ListItem"));
var _ListItemText = _interopRequireDefault(require("../../ListItemText"));
var _Listbox = _interopRequireDefault(require("../../Listbox"));
var _Modal = _interopRequireDefault(require("../../FullScreenModal/Modal"));
var _index = _interopRequireDefault(require("./index.style"));
var _Card = _interopRequireDefault(require("../../Card"));
var _Header = _interopRequireDefault(require("../../Header"));
var _NavLink = _interopRequireDefault(require("../../NavLink"));
var _Typography = _interopRequireDefault(require("../../Typography"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AutocompleteModal = props => {
  const classes = (0, _index.default)();
  const {
    options = [],
    hideIconOn = [],
    getInputLabel = option => option.label,
    getOptionLabel = option => option.label,
    getSelectedValue = () => {},
    noResultsErrorMessage,
    placeholder,
    id = 'acModal',
    label = '',
    className,
    acIcon = /*#__PURE__*/_react.default.createElement(_AirplanemodeActive.default, null),
    InputProps = {
      startAdornment: /*#__PURE__*/_react.default.createElement(_core.Hidden, {
        only: hideIconOn
      }, /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement(_FlightTakeoff.default, null)))
    },
    setModalValue = () => {},
    modalProps,
    modalIsOpen,
    closeModal,
    ...others
  } = props;
  const textFieldRef = (0, _react.useRef)();
  const handleCloseModal = () => {
    textFieldRef.current.blur();
    closeModal();
  };
  const {
    dirty,
    focused,
    getRootProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    inputValue,
    value
  } = (0, _useAutocomplete.default)({
    id,
    options,
    openOnFocus: true,
    onChange: (event, selectedValue) => {
      getSelectedValue(selectedValue);
    },
    getOptionLabel: getInputLabel,
    open: true
  });
  const handleDoneModal = selectedValue => {
    setModalValue(selectedValue);
    textFieldRef.current.blur();
    closeModal();
  };
  const hasGroupedOptions = groupedOptions.length > 0;
  const shouldDisplayError = focused && getInputProps().value !== '' && (dirty ? inputValue !== getInputLabel(value) : true) && !hasGroupedOptions;
  const autoFocus = true;
  (0, _react.useEffect)(() => {
    if (modalIsOpen) {
      textFieldRef.current.focus();
    }
  }, [modalIsOpen]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, (0, _extends2.default)({}, modalProps, {
    padding: false,
    closeButton: false
  }, getRootProps()), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Header.default, {
    position: "relative",
    elevation: 0
  }, /*#__PURE__*/_react.default.createElement(_NavLink.default, {
    component: "a",
    onClick: handleCloseModal
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    className: classes.modalHeaderLabel
  }, "Back"))), /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: classes.wrapText
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({}, getInputProps(), {
    onChange: event => {
      getInputProps().onChange(event);
    },
    label: label,
    placeholder: placeholder,
    InputProps: InputProps
    // eslint-disable-next-line react/jsx-no-duplicate-props
    ,
    inputProps: {
      'data-testid': 'acModal'
    },
    helperText: shouldDisplayError && noResultsErrorMessage,
    error: shouldDisplayError,
    title: inputValue || placeholder,
    autoFocus: autoFocus,
    inputRef: textFieldRef
  }, others)))), /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: classes.listBoxWrapper
  }, options ? /*#__PURE__*/_react.default.createElement(_Listbox.default, (0, _extends2.default)({}, getListboxProps(), {
    className: classes.listBoxResult
  }), groupedOptions.map((option, index) => /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
    key: "list-item-modal-".concat(option)
  }, getOptionProps({
    option,
    index
  }), {
    onClick: () => {
      handleDoneModal(option);
    }
  }), /*#__PURE__*/_react.default.createElement(_ListItemText.default, null, acIcon, " ", getOptionLabel(option))))) : null));
};
var _default = exports.default = AutocompleteModal;